import { UploadCloud } from 'lucide-react';

interface Props {
  visible: boolean;
}

/** Overlay de tela inteira mostrado enquanto um arquivo é arrastado sobre a área principal. */
export function GlobalDropOverlay({ visible }: Props) {
  if (!visible) return null;
  return (
    <div className="bg-background/90 border-primary pointer-events-none absolute inset-0 z-40 flex flex-col items-center justify-center gap-3 border-2 border-dashed">
      <UploadCloud className="text-primary size-10" />
      <p className="text-sm font-medium">Solte para enviar</p>
    </div>
  );
}
